'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var faQuestionCircle = require('@fortawesome/sharp-solid-svg-icons/faQuestionCircle');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var react = require('@headlessui/react');
var twMerge = require('../../tw-merge-2e22aa15.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/* eslint-disable tailwindcss/no-custom-classname */
function Tooltip(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      content = _ref.content,
      children = _ref.children,
      _ref$hasIcon = _ref.hasIcon,
      hasIcon = _ref$hasIcon === void 0 ? true : _ref$hasIcon;
  var buttonRef = React__default["default"].useRef(null);
  var timeoutDuration = 200;
  var timeout;

  var closePopover = function closePopover() {
    var _buttonRef$current;

    return (_buttonRef$current = buttonRef.current) == null ? void 0 : _buttonRef$current.dispatchEvent(new KeyboardEvent('keydown', {
      key: 'Escape',
      bubbles: true,
      cancelable: true
    }));
  };

  var onMouseEnter = function onMouseEnter(open) {
    var _buttonRef$current2;

    clearTimeout(timeout);
    if (open) return;
    return (_buttonRef$current2 = buttonRef.current) == null ? void 0 : _buttonRef$current2.click();
  };

  var onMouseLeave = function onMouseLeave(open) {
    if (!open) return;
    timeout = setTimeout(function () {
      return closePopover();
    }, timeoutDuration);
  };

  return /*#__PURE__*/React__default["default"].createElement(react.Popover, {
    className: "relative"
  }, function (_ref2) {
    var open = _ref2.open;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      onMouseLeave: onMouseLeave.bind(null, open)
    }, /*#__PURE__*/React__default["default"].createElement(react.Popover.Button, {
      ref: buttonRef,
      "aria-label": "Tooltip button",
      onMouseEnter: onMouseEnter.bind(null, open),
      onMouseLeave: onMouseLeave.bind(null, open)
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "flex items-center"
    }, children, hasIcon && /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: faQuestionCircle.faQuestionCircle,
      className: "text-primary-base ml-1 antialiased"
    }))), /*#__PURE__*/React__default["default"].createElement(react.Transition, {
      show: open,
      as: React__default["default"].Fragment,
      enter: "transition ease-out duration-200",
      enterFrom: "opacity-0 translate-y-1",
      enterTo: "opacity-100 translate-y-0",
      leave: "transition ease-in duration-150",
      leaveFrom: "opacity-100 translate-y-0",
      leaveTo: "opacity-0 translate-y-1"
    }, /*#__PURE__*/React__default["default"].createElement(react.Popover.Panel, {
      static: true,
      className: twMerge.twMerge('bg-basic-darker z-10 mx-auto absolute shadow-tyro p-4 text-white font-medium text-xs min-w-[15.625rem]', className)
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      onMouseEnter: onMouseEnter.bind(null, open),
      onMouseLeave: onMouseLeave.bind(null, open)
    }, content))));
  });
}

exports.Tooltip = Tooltip;
